import _ from "lodash";
import SoftBox from "components/SoftBox";
import InvoiceContext from "context/InvoiceContext";
import { useContext, useEffect } from "react";
import ApiService from "services/ApiService";
import SoftButton from "components/SoftButton";
import { Icon, Tooltip } from "@mui/material";
import Constants from "utils/Constants";
import StorageService from "services/StorageService";

function UserInvoiceCount() {
  const { invoiceCount, setInvoiceCount } = useContext(InvoiceContext);
  const accessLevel = StorageService.getAccessLevel();
  const getUserInvoices = async () => {
    const response = await ApiService.getData(`/api/v1/users/me/available-credits`);
    const userCredits = _.get(response, "data.credits");
    setInvoiceCount(userCredits);
  };

  useEffect(() => {
    getUserInvoices();
  }, []);

  return accessLevel === Constants.ACCESS_LEVELS.USER ? (
    <SoftBox
      border="2px solid dark"
      borderRadius="lg"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={1}
      mt={0}
    >
      <SoftBox ml="auto" lineHeight={0}>
        <Tooltip title={invoiceCount} placement="bottom" enterTouchDelay={0}>
          <SoftButton variant="outlined" color="secondary" size="small" iconOnly circular>
            <Icon sx={{ cursor: "pointer" }}>receipt_long</Icon>
          </SoftButton>
        </Tooltip>
      </SoftBox>
    </SoftBox>
  ) : accessLevel === Constants.ACCESS_LEVELS.MASTER ? (
    <SoftBox
      border="2px solid dark"
      borderRadius="lg"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={1}
      mt={0}
    >
      <SoftBox ml="auto" lineHeight={0}>
        <Tooltip title="&infin;" placement="bottom" enterTouchDelay={0}>
          <SoftButton variant="outlined" color="secondary" size="small" iconOnly circular>
            <Icon sx={{ cursor: "pointer" }}>receipt_long</Icon>
          </SoftButton>
        </Tooltip>
      </SoftBox>
    </SoftBox>
  ) : (
    ""
  );
}

export default UserInvoiceCount;
